import s from './CustomRadioElem/CustomRadioElem.module.css';
import './and-design.css';
import { Select } from "antd";
import React, { useState } from "react";
import { DeleteChatIcon } from "@/utils/icons";
import classNames from "classnames";
import UserImage from "@common/Chat/components/UserImage/UserImage";
import { chatApi } from "@/api";
import { useAddAlert } from "@/hooks/useAddAlert";
import useOpenPrivateChatFromGroupChat from "@/hooks/useOpenPrivateChatFromGroupChat";
import OpenPrivateChatButton from "./OpenPrivateChatButton";
import { roleAdminInChat, rolesChatParticipants } from '../constants';

const MemberElem = ({ user, myRoleInChat, setIsVisiblePopup, setHeader, setDelId, setType, setIsNeedUpdated, setPage, isGroupChat }) => {
    const addAlert = useAddAlert();
    const { canOpenPrivateChat, openPrivateChat } = useOpenPrivateChatFromGroupChat({
        isGroupChat,
        targetUserId: user?.user_id,
        setPage,
    });

    const options = [
        {
            label: 'Участник',
            value: 1
        },
        {
            label: 'Администратор',
            value: 2
        },
        {
            label: 'Читатель',
            value: 3
        },
    ];

    const myRole = options.find(el => el.value === user.role);
    const [role, setRole] = useState(myRole);

    const handleChange = (value) => {
        setRole(value);
        chatApi.updateRoleMember(user.member_id, {
            role: value
        }).then(() => setIsNeedUpdated(true)).catch(err => addAlert({ text: err }));
    };

    const handleDelete = () => {
        setHeader('Вы действительно хотите удалить участника?');
        setIsVisiblePopup(true);
        setDelId(user.member_id);
        setType('removeMember');
    };

    const isChatAdmin = rolesChatParticipants[myRoleInChat] === roleAdminInChat;

    return (
        <div className={classNames(s.row, 'custom-radio-element')}>
            <div className={s.rowHead}>
                <UserImage path={user.avatar} />
                <div className={s.rowName}>{user.name}</div>
                {canOpenPrivateChat && (
                    <OpenPrivateChatButton
                        className={classNames(s.btn, s.messageBtn)}
                        onClick={openPrivateChat}
                    />
                )}
            </div>
            <div className={s.controls}>
                <Select
                    disabled={!isChatAdmin || user?.isCreator === 1}
                    onChange={(value) => handleChange(value)}
                    options={options}
                    value={role}
                    popupClassName={'custom-dropdown'} size={'middle'}
                >
                    <Select.Option value="2" style={{ fontSize: '12px' }}>Администратор</Select.Option>
                    <Select.Option value="1">Участник</Select.Option>
                    <Select.Option value="3">Читатель</Select.Option>
                </Select>
                {
                    isChatAdmin && (
                        <div className={s.btn} onClick={handleDelete}>
                            <DeleteChatIcon width={'24'} height={'24'} />
                        </div>
                    )
                }
            </div>

        </div>
    );
};

export default MemberElem;
